<template>
    <div class="xi" style="background: #F5F5F5;">
        <hd-com></hd-com>
        <div class="banner">
            <div class="banner-text">
                <p>当前位置：<router-link to="/index">首页</router-link><i class="el-icon-arrow-right"></i><a>普通问诊</a><i class="el-icon-arrow-right"></i><a>医生详情</a><i class="el-icon-arrow-right"></i><a>问诊详情</a></p>
            </div>
        </div>
        <div class="contentRes">
            <div class="contentList">
                <div class="drugTitle">
                    <div :class="showStep >= 1 ? 'stepShowclass' : ''">
                        填写信息
                        <i style="margin-left: 5px;" class="el-icon-arrow-right"></i>
                    </div>
                    <div :class="showStep >= 2 ? 'stepShowclass' : ''">
                        病情评估
                        <i style="margin-left: 5px;" class="el-icon-arrow-right"></i>
                    </div>
                    <div :class="showStep >= 3 ? 'stepShowclass' : ''">
                        支付费用
                        <i style="margin-left: 5px;" class="el-icon-arrow-right"></i>
                    </div>
                    <div :class="showStep == 4 ? 'stepShowclass' : ''">
                        医生接诊
                    </div>
                </div>
                <div class="contentStep1Box" v-if="showStep == 1">
                    <div class="step1Title">患者信息<span style="color:#EC0101">*</span></div>
                    <div class="step1PatientBox">
                        <div class="step1PatientListBox" @click="addPatient">
                            + 新建患者
                        </div>
                        <div :class="currDocindex == index ? 'step1PatientListBoxCheck' : 'step1PatientListBox' " v-for="(item,index) in listDocData" :key="index" @click="gochooseUser(item,index)">
                            <span style="font-weight: bold;font-size: 16px;">{{item.name}}</span>
                            <span style="margin-left:15px" >{{item.sex == true ? '男' : '女'}}</span> 
                            <span style="margin:0 5px">|</span> 
                            <span >{{item.age}}</span>岁
                            <span style="margin:0 5px">|</span> 
                            <span v-if="item.relationshipToPatient == 0">本人</span>
                            <span v-if="item.relationshipToPatient == 1">子女</span>
                            <span v-if="item.relationshipToPatient == 2">父母</span>
                            <span v-if="item.relationshipToPatient == 3">其他</span>
                        </div>
                    </div>
                    <div class="DocTopFlexS" style="margin-top:25px;margin-bottom:25px">
                        <div class="step1Title">病情描述<span style="color:#EC0101">*</span></div>
                        <div style="font-size: 16px;color: #00AFB5;cursor: pointer;" @click="goHisList">+ 导入历史病情</div>
                    </div>
                    <div class="step2Title" style="margin-bottom:15px">疾病名称/症状 <span style="color:#EC0101">*</span></div>
                    <el-input
                        class="diseaseBox"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入疾病名称/症状"
                        v-model="diseaseName">
                    </el-input>
                    <div class="step2Title" style="margin-bottom:15px;margin-top:25px">详细描述 <span style="color:#EC0101">*</span></div>
                    <el-input
                        class="diseaseBox"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入详细描述"
                        v-model="diseaseDes">
                    </el-input>
                    <div class="step2Title" style="margin-bottom:15px;margin-top:25px">上传检查报告/患处照片</div>
                    <el-upload :headers="headers" :action="FileUploadUrl" list-type="picture-card" :file-list="ImageContent" :limit="5" multiple :on-preview="handleImagePreview" :on-remove="handleImageRemove" :on-success="handleImageUpload" :on-exceed="$imgConfig.exceed" :before-upload="$imgConfig.onBeforeUpload" accept=".png,.jpg,.jpeg,.gif">
                      <i class="el-icon-plus"></i>
                  </el-upload>
                    <div v-if="showStep == 1" class="DocTopFlexC" style="margin-top:50px">
                        <div class="canBtnBox" @click="goCanBtn">
                            取消
                        </div>
                        <div class="stepBtnBox" @click="goNextStep">
                            下一步:病情评估
                        </div>
                    </div>
                </div>
                <quesTowStep v-if="showStep == 2" :mesStep1='paramsType' @orderInfo="handleChildOrder" :patientDiagnoseDetail1= 'patientDiagnoseDetail'></quesTowStep>
                <quesTreeStep v-if="showStep == 3" :stepDownTree1='stepDownTree' :DoctorType1="DoctorType"></quesTreeStep>
            </div>
            <div class="contentListRight">
                <div style="margin: 19px 31px 28px 23px;">
                    <div class="contentListTopR">
                        <div class="contentListLineR"></div><span>温馨提示</span>
                    </div>
                    <div style="font-size: 16px;color: #FF0000;line-height: 24px;margin-top:18px">
                        本系统仅提供辅助参考功能，诊疗决策须由执业医师独立完成，提交的所有内容，仅您本人与医生可见，请放心！
                    </div>
                </div>
            </div>
            <el-dialog
                title="新建患者"
                :visible.sync="addDialogVisible"
                width="40%"
                :before-close="addhandleClose"
            >
                <el-form label-position="left" label-width="80px" :model="patientList"  ref="patientList" :rules = rules>
                    <el-form-item label="患者姓名" prop='name'>
                        <el-input v-model="patientList.name" placeholder="请输入患者姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="患者性别">
                        <div class='DocTopFlexC' >
                            <div :class="cursexIndex == 1 ? 'evaBoxCheck' : 'evaBox' " @click="gosexCurIndex(1)">男</div>
                            <div :class="cursexIndex == 2 ? 'evaBoxCheck' : 'evaBox' " @click="gosexCurIndex(2)">女</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="出生日期" prop='birthday'>
                        <el-date-picker type="date" placeholder="请选择患者出生日期" v-model="patientList.birthday" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="所在地区" prop="regionId">
                        <el-cascader :placeholder="patientList.regionName ? patientList.regionName : '请选择所在区域'" v-model="patientList.regionId" :options="RegionData" size="medium" :props="{ emitPath: false, multiple: false, checkStrictly: true, lazy: true, lazyLoad: LasyLoadRegion, value: 'id', label: 'regionName', children: 'childrens' }" style="margin-right: 10px; width: 100%" @change="gochange" ref="refSubCat"> </el-cascader>
                    </el-form-item>
                    <el-form-item label="患者关系">
                        <div class='DocTopFlexC' >
                            <div :class="curIndex == 0 ? 'BoxCheckG' : 'BoxG' " @click="goCurIndex(0)">本人</div>
                            <div :class="curIndex == 1 ? 'BoxCheckG' : 'BoxG' " @click="goCurIndex(1)">子女</div>
                            <div :class="curIndex == 2 ? 'BoxCheckG' : 'BoxG' " @click="goCurIndex(2)">父母</div>
                            <div :class="curIndex == 3 ? 'BoxCheckG' : 'BoxG' " @click="goCurIndex(3)">其他</div>
                        </div>
                    </el-form-item>
                    <el-form-item label="联系电话" prop="phone">
                        <el-input v-model="patientList.phone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item style="text-align:right">
                        <el-button @click="cancelOnSubmit('patientList')">取消</el-button>
                        <el-button type="primary" @click="goOnSubmit('patientList')">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
            <el-dialog :visible.sync="Image.dialogVisible">
                  <img width="100%" :src="Image.dialogImageUrl" alt="" />
            </el-dialog>
            <el-drawer
                title="导入历史病情"
                :visible.sync="hisdrawer"
                direction="rtl"
                >
                <div class="drawBoxBtn" style="top: 50px;"  >
                    <div class="DocTopFlexC " style="    justify-content: flex-end;">
                        <el-button @click="cancelDisease">取消</el-button>
                        <el-button type="primary" @click="goOnDisease">导入</el-button>
                    </div>
                    <div style="width:100%;height:20px;"></div>
                </div>
                <div class="drawBoxList">
                    <div :class="diseaseListIndex == index ? 'step1disListBoxCheck' : 'step1disPatientListBox' " v-for="(item,index) in diseaseList" :key="index" @click="goDiseaseList(item,index)">
                        <div style="font-weight: bold;font-size: 16px;" class="DocTopFlexS">
                            <div>疾病:{{item.diseaseDiagnose}}</div>
                            <div style="color:#00A8AE; cursor: pointer;" @click.stop="goDiseaseListDetail(item,index)">查看病历</div>
                        </div>
                        <div style="" >病情描述：{{item.description}}</div> 
                        <div style="margin:0 5px; color:#999999">病历：{{item.addTime.split('T')[0]}}填写</div>
                    </div>
                    <div v-if="diseaseList.length == 0" style="margin-top:50px; display: flex;align-items: center;flex-direction: column;">
                        <img src="../../assets/img/reservation/adefault.png" style="width:256px;height:140px;" alt="" srcset="">
                        <span style="color: #666666;">暂无数据！</span>
                    </div>
                </div>

            </el-drawer>
            <el-drawer
                title="历史病情"
                :visible.sync="hisdrawerDetail"
                direction="rtl"
            >
                <div class="drawBoxBtn">
                    <div class="DocTopFlexC " style="    justify-content: flex-end;">
                        <el-button @click="cancelDisease1">取消</el-button>
                        <el-button type="primary" @click="goOnDisease">导入</el-button>
                    </div>
                    <div style="width:100%;height:20px;"></div>
                </div>
                <div class="box2" >
                    <div class="userInfo">
                        <div class="doctor-1">
                        {{ detailInfo.name }} {{ detailInfo.sex ? "男" : "女" }} {{ getAge(detailInfo?.birthday) }}岁（{{ detailInfo.birthday?.split("T")[0] }}）
                        <template v-if="detailInfo.relationshipToPatient == 0">本人</template>
                        <template v-if="detailInfo.relationshipToPatient == 1">子女</template>
                        <template v-if="detailInfo.relationshipToPatient == 2">父母</template>
                        <template v-if="detailInfo.relationshipToPatient == 3">其他</template>
                        </div>
                        <div class="desc" style="text-align: left; margin-bottom: 20px; margin-top: 10px; align-items: start">
                        <h4 style="color: #00A8AE; width: 100%">就诊疾病</h4>
                        <div class="right-val">{{ detailInfo.diseaseDiagnose }}</div>
                        </div>
                        <div v-if=" detailInfo.diseaseImage != ''">
                            <span style="font-weight: bold">检查报告/患者处方照片</span>
                            <div class=" flex-start flex-warp">
                                <div v-for="(files,i) in detailInfo.diseaseImage" :key="i">
                                <el-image fit="cover" style="width: 100px;height: 100px;margin-right: 5px;margin-bottom: 5px;" hide-on-click-modal :src="Services.ossUpload + files.filePath" preview-teleported :zoom-rate="1.2" :preview-src-list="[Services.ossUpload + files.filePath]"></el-image>
                                </div>
                            
                            </div>
                        </div>
                        <div v-if="detailInfo.patientAnswerRecords">
                            <div class="desc" style="text-align: left; align-items: start; margin-bottom: 20px">
                                <h4 style="color: #00A8AE">详细病情</h4>
                                <div style="margin-bottom: 8px">
                                    <div class="left-title" style="margin: 5px 0; width: 100%">病情描述</div>
                                    <div class="right-val">{{ detailInfo?.description }}</div>
                                </div>
                                <div style="margin-bottom: 8px">
                                    <div class="left-title" style="margin: 10px 0 5px 0; width: 100%">患病时长</div>
                                    <div class="right-val">{{ detailInfo.patientAnswerRecords[1].userAnswer[0].quesAnsName }}</div>
                                </div>
                                <div style="margin-bottom: 8px" v-if="detailInfo?.patientAnswerRecords[3]?.userAnswer[0]?.quesAnsName == '有'">
                                    <div class="left-title" style="margin: 10px 0 5px 0; width: 100%">当前正在使用的药物</div>
                                    <div class="right-val">{{ detailInfo?.patientAnswerRecords[3]?.userAnswer[0]?.otherData[0]?.patientHisDrug }}</div>
                                </div>
                            </div>
                            <div class="desc" style="text-align: left; align-items: start; margin-bottom: 20px" v-if="detailInfo?.patientAnswerRecords[4]?.userAnswer[0]?.quesAnsName == '有' || detailInfo?.patientAnswerRecords[5]?.userAnswer[0]?.quesAnsName == '有'">
                                <h4 style="color: #00A8AE">既往史</h4>
                                <template v-if="detailInfo?.patientAnswerRecords[4]?.userAnswer[0]?.quesAnsName == '有'">
                                    <div style="margin-bottom: 8px" v-for="(item, index) in detailInfo?.patientAnswerRecords[4]?.userAnswer[0]?.otherData" :key="index">
                                    <div class="left-title" style="margin: 5px 0; width: 100%">{{ item.name }}</div>
                                    <div class="right-val">{{ item.des }}</div>
                                    </div>
                                </template>
                                <div style="margin-bottom: 8px" v-if="detailInfo?.patientAnswerRecords[5]?.userAnswer[0]?.quesAnsName == '有'">
                                    <div class="left-title" style="margin: 10px 0 5px 0; width: 100%">慢性病史</div>
                                    <div class="right-val">{{ detailInfo?.patientAnswerRecords[5]?.userAnswer[0]?.otherData[0]?.diseasesDes }}</div>
                                </div>
                            </div>
                            <div class="desc" style="text-align: left; margin-bottom: 20px; align-items: start">
                                <h4 style="color: #00A8AE; width: 100%">体格检查</h4>
                                <div class="right-val">{{ detailInfo?.patientAnswerRecords[0]?.userAnswer[0]?.otherData[0]?.patientHeight }}cm,{{ detailInfo.patientAnswerRecords[0]?.userAnswer[0]?.otherData[0]?.patientWeight }}kg({{ detailInfo?.patientAnswerRecords[0]?.userAnswer[0]?.otherData[0]?.patienTtestTime }}测量)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-drawer>
        </div>
        <ft-com></ft-com>
    </div>
</template>

<script>
import { consultationMain } from "../../components/consultation/consultation";
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
import hdCom from '../../components/header'
import ftCom from '../../components/footer'
import quesTowStep from '../../components/consultation/quesTowStep.vue'
import quesTreeStep from '../../components/consultation/quesTreeStep.vue'
export default {
    components: {
        hdCom,
        ftCom,
        quesTowStep,
        quesTreeStep
    },
    data() {
        var consultationMainItem = new consultationMain(this.TokenClient, this.Services.Authorization);
        var consultationDrugItem = new consultationMain(this.TokenClient, this.Services.Drug);
        var region = new shoppingMall(this.TokenClient, this.Services.Authorization);
        return {
            consultationDomain: consultationMainItem,
            consultationDrugDomain:consultationDrugItem,
            Region: region,
            userInfo: this.$store.state.localData.userInfo,
            patientId:'',
            patientPhone:'',
            diseaseName:'',
            diseaseDes:'',
            listDocData:[],
            showStep:1,
            addDialogVisible:false,
            RegionData: [],
            patientList:{
                name:'',
                birthday:'',
                phone:'',
                regionName:'',
                regionId:'',
				regionCode:'',
                sex:true
            },
            cursexIndex:1,
            curIndex:0,
            currDocindex:0,
            hisdrawer:false,
            rules: {
                birthday: [{ required: true, message: "请选择患者出生日期", trigger: "blur" }],
                name: [{ required: true, message: "请输入患者姓名", trigger: "blur" }],
                phone: [
                { required: true, message: "请输入联系电话", trigger: "blur" },
                { pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/, message: "请输入合法手机号/电话号", trigger: "blur" },
                ],
            },
            asstoken:'',
            FileUploadUrl: this.Services.Statics + "/api/upload",
            Image: {
                //单击图片上传控件中的图片时，放大显示
                dialogVisible: false,
                dialogImageUrl: "",
            },
            ImageContent:[],
            DoctorType:this.$route.query.type,
            DoctorId:this.$route.query.DocId,
            paramsType:{},
            stepDownTree:{},
            patientDiagnoseDetail:{},
            diseaseList:[],
            diseaseListIndex:-1,
			diseaseListId:0,
            hisdrawerDetail:false,
            detailInfo:{},
            http:''
        }
    },
    computed: {
        headers() {
        return {
            Authorization: "Bearer" + " " + this.asstoken,
        };
        },
    },
    async mounted(){
        this.asstoken = await this.TokenClient.AccessToken();
        this.http = this.Services.ossUpload;
        this.getDocListData()
    },
    methods: {
        getAge(date) {
            const birthDate = new Date(date);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },
        goDiseaseList(e,index){
            this.diseaseListIndex = index
            this.diseaseListId = e.id
        },
        cancelDisease(){
            this.hisdrawer = false
        },
        cancelDisease1(){
            this.hisdrawerDetail = false
        },
        goDiseaseListDetail(e,index){
            var _this = this 
            _this.diseaseListIndex = index
            _this.diseaseListId = e.id
            _this.consultationDrugDomain.GetDiagnoseDetail(e.id, function (data) {
                _this.detailInfo = data.data;
                if(_this.detailInfo.diseaseImage){
                    _this.detailInfo.diseaseImage=JSON.parse(_this.detailInfo.diseaseImage)
                }
                _this.detailInfo.patientAnswerRecords.map((res) => {
                    res.userAnswer = JSON.parse(res.userAnswer);
                });
                _this.hisdrawerDetail = true
                console.log( _this.detailInfo)
            },
            function (error) {
                console.log('', error)
            })  
        },
        goOnDisease(){
            var _this = this
            if (_this.diseaseListIndex == -1) {
                _this.$message.error('请选择导入的病情');
                return
            }
            _this.consultationDrugDomain.GetDiagnoseDetail(_this.diseaseListId, function (data) {
                _this.paramsType = {
                    orderType:_this.DoctorType,
                    doctorId:_this.DoctorId,
                    patientId:_this.patientId,
                    diseaseDiagnose:data.data.diseaseDiagnose,
                    description:data.data.description,
                    diseaseImage:data.data.diseaseImage,
                    patientAnswerRecords:[]
                }
                _this.ImageContent=[]
                if(data.data.diseaseImage){
                    _this.ImageContent=JSON.parse(data.data.diseaseImage)
                    console.log(_this.ImageContent)
                    _this.ImageContent.map(res=> {
                        res.url = _this.http + res.filePath
                    })
                }
                _this.patientDiagnoseDetail = data.data
                _this.diseaseName =  data.data.diseaseDiagnose
                _this.diseaseDes =  data.data.description
                _this.hisdrawer = false
                _this.hisdrawerDetail = false
            },
            function (error) {
                console.log('', error)
            })  
        },
        GetDiagnoseListData(){
            var _this = this
            _this.consultationDrugDomain.GetDiagnoseList(_this.patientId, function (data) {
                _this.diseaseList = data.data.results
            },
            function (error) {
                console.log('', error)
            })
        },
        handleChildOrder(e){
            this.stepDownTree = e.info
            this.stepDownTree.phone = this.patientPhone
            this.showStep = e.number
        },
        goNextStep(){
            if (!this.diseaseName) {
                this.$message.error('请输入疾病名称/症状');
                return
            }
            if (!this.diseaseDes) {
                this.$message.error('请输入详细描述');
                return
            }
            this.paramsType = {
                orderType:this.DoctorType,
                doctorId:this.DoctorId,
                patientId:this.patientId,
                diseaseDiagnose:this.diseaseName,
                description:this.diseaseDes,
                diseaseImage:this.ImageContent.length > 0 ? JSON.stringify(this.ImageContent) : '',
                patientAnswerRecords:[]
            }
            this.showStep = 2
        },
        goCanBtn(){
            this.$confirm('确认取消本次问诊吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$router.back();
                }).catch(() => {

            });
        },
        handleImagePreview(file) {
            this.Image.dialogImageUrl = file.url;
            this.Image.dialogVisible = true;
        },
        handleImageRemove(file, fileList) {
            var _this = this;
            const filePath = file.response[0].completeFilePath;
            //2.从pics数组中找到图片对应的索引值
            //形参‘x’，是数组pic里的每一项
            const i = _this.ImageContent.findIndex((x) => x.completeFilePath == filePath);
            //调用数组的splice方法，把图片的信息对象从pics数组中移除
            _this.ImageContent.splice(i, 1);
              console.log(_this.ImageContent)
        },
        handleImageUpload(response, file, fileList) {
            var _this = this;
            response.forEach(function (file) {
                var imgarr = {
                filePath: file.completeFilePath,
                fileName: file.fileName,
                type: 0,
                url:_this.http + file.completeFilePath
                };
                _this.ImageContent.push(imgarr);
            });
            console.log(_this.ImageContent)
        },
        goHisList(){
            this.hisdrawer = true
            this.GetDiagnoseListData()
        },
        gochooseUser(item,index){
            this.currDocindex = index
            this.patientId = item.id
            this.patientPhone = item.phone
        },
        goOnSubmit(formName){
            var _this = this
            _this.$refs[formName].validate((valid) => {
            if (valid) {
                let params = {
                    name:_this.patientList.name,
					sex:_this.cursexIndex == 1 ? true : false,
					birthday:_this.patientList.birthday,
					regionId:_this.patientList.regionId,
					address:_this.patientList.regionName,
					relationshipToPatient:_this.curIndex,
					patientType:5,
					phone:_this.patientList.phone,
					userId:_this.userInfo.id
                }
                _this.consultationDomain.getAddPatient(params, function (data) {
                    _this.addDialogVisible = false
                    _this.$refs[formName].resetFields();
                    _this.getDocListData()
                },
                function (error) {
                    
                    console.log('', error)
                })
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        cancelOnSubmit(formName){
            this.$refs[formName].resetFields();
            this.addDialogVisible = false
        },
        addhandleClose(){
            this.patientList = {
                name:'',
                birthday:'',
                phone:'',
                regionName:'',
                regionId:'',
				regionCode:'',
                sex:true
            },
            this.cursexIndex = 1
            this.curIndex = 0
            this.addDialogVisible = false
        },
        gosexCurIndex(e){
            this.cursexIndex = e
        },
        goCurIndex(e){
            this.curIndex = e
        },
        gochange() {
            console.log(this.$refs["refSubCat"].getCheckedNodes()[0].data)
            this.patientList.regionName = this.$refs["refSubCat"].getCheckedNodes()[0].data.fullName;
            this.patientList.regionId = this.$refs["refSubCat"].getCheckedNodes()[0].data.id;
        },
        InitialRegion() {
            var _this = this;
            _this.Region.Regions(
                null,
                function (data) {
                _this.RegionData = data.data;
                },
                function (err) {
                console.log(err);
                }
            );
        },
        LasyLoadRegion(node, resolve) {
            var _this = this;
            _this.Region.Regions(
                node.value,
                function (data) {
                for (var dataIndex = 0; dataIndex < data.data.length; dataIndex++) {
                    data.data[dataIndex].leaf = data.data[dataIndex].regionLevel >= 3;
                }
                resolve(data.data);
                },
                function (err) {
                resolve([]);
                }
            );
        },
        addPatient(){
            this.InitialRegion()
            this.addDialogVisible = true
        },
        getDocListData(){
            var _this = this
            _this.consultationDomain.GetPatientMyself(_this.userInfo.id, function (data) {
                _this.listDocData = data.data.results
                _this.listDocData.map((res)=>{
                    res.age = _this.sumTotalage(res.birthday)
                })
                _this.patientId = _this.listDocData[0].id
                _this.patientPhone = _this.listDocData[0].phone
            },
            function (error) {
                 _this.listDocData = []
                console.log('', error)
            })
        },
        sumTotalage(time) {
            // 将输入的日期字符串转换为Date对象
            const birthDateObj = new Date(time);
            // 获取当前日期
            const currentDate = new Date();
            // 计算年龄，这里用的是年份差，不考虑月份和日期的差异，可根据需要调整
            let age = currentDate.getFullYear() - birthDateObj.getFullYear();
            // 检查是否已过今年的生日，未过则减去1岁
            const m = currentDate.getMonth() - birthDateObj.getMonth();
            if (m < 0 || (m === 0 && currentDate.getDate() < birthDateObj.getDate())) {
            age--
            }
            return age
        },
    },
}
</script>

<style scoped>
.banner-text {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 10px;
}
.contentRes {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    min-height: 800px;
    margin-bottom: 20px;
}
.contentList {
    margin-top: 20px;
    width: 800px;
}
.contentListRight {
    width: 380px;
    height: 180px;
    background: #FFFFFF;
    margin-top: 20px;
}
.contentListTopR {
    display: flex;
    align-items: center;
}
.contentListLineR {
    width: 3px;
    height: 20px;
    background: #FF0000;
    border-radius: 2px;
}
.contentListTopR span {
   font-size: 20px;
   margin-left: 10px;
   color: #FF0000;
}
.DocTopFlexC {
    display: flex;
    align-items: center;
}
.DocTopFlexS {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.drugTitle {
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    padding: 15px 25px;
    font-size: 16px;
    color: #999999;
}
.stepShowclass {
    color: #333333;
    font-weight: bold;
} 
.contentStep1Box {
    margin-top: 15px;
    padding: 30px;
    padding-bottom: 60px;
    background-color: #FFFFFF;
}
.step1Title {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
}
.step2Title {
    font-size: 16px;
    color: #333333;
}
.step1PatientBox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.step1PatientListBox {
    width: 300px;
    padding: 20px 0;
    text-align: center;
    background: #F5F5F5;
    border-radius: 4px;
    font-size: 16px;
    color: #333333;
    margin-right: 20px;
    margin-top: 20px;
    cursor: pointer;
}
.step1PatientListBoxCheck {
    width: 300px;
    padding: 20px 0;
    text-align: center;
    background: #F2FEFE;
    border-radius: 4px;
    border: 1px solid #00AFB5;
    font-size: 16px;
    color: #333333;
    margin-right: 20px;
    margin-top: 20px;
    cursor: pointer;
}
.evaBox {
    background: #F5F5F5;
    border-radius: 4px;
    font-size: 14px;
    color: #333333;
     width: 50px;
    margin-right: 12px;
    cursor: pointer;
     text-align: center;
}
.evaBoxCheck {
    width: 50px;
    border-radius: 4px;
    background: #00AFB5;
    font-size: 14px;
    color: #FFFFFF;
    margin-right: 12px;
    cursor: pointer;
    text-align: center;
}
.BoxCheckG {
    width: 60px;
    background: #F3F9F9;
    border-radius: 4px;
    border: 1px solid #B9DCDD;
    font-size: 14px;
    color: #00AFB5;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
}
.BoxG {
    width: 60px;
    background: #F5F5F5;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    margin-right: 10px;
}
 .diseaseBox ::v-deep textarea{
    background: #F5F5F5 !important;
    border-radius: 4px;
    border: none;
}
.canBtnBox {
    width: 80px;
    background: #EDEDED;
    border-radius: 4px;
    font-size: 16px;
    color: #333333;
    text-align: center;
    padding: 5px 0;
    cursor: pointer;
}
.stepBtnBox {
    width: 180px;
    background: #00AFB5;
    border-radius: 4px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
     padding: 5px 0;
    margin-left: 10px;
    cursor: pointer;
}
.step1disListBoxCheck {
    background: #F3F9F9;
    border-radius: 2px;
    border: 1px solid #B9DCDD;
    padding: 16px;
    margin: 0 20px;
    margin-bottom: 15px;
   
}
.step1disPatientListBox {
    background: #F5F5F5;
    border-radius: 2px;
    padding: 16px;
    margin: 0 20px;
    margin-bottom: 15px;

}
.drawBoxList {
    /* max-height: 500px;
    overflow:hidden;
    overflow-y: auto; */
    /* position: absolute;
    top: 0;
    right: 20px; */
    margin-top: 50px;
}
.drawBoxBtn {
    background-color: #ffffff;

    margin-right:20px;
    position: absolute;
    top: 70px;
    right: 15px;
}
.box2 {
  border-radius: 6px;
  width: 90%;
  margin: 0px auto;
}
.userInfo {
  margin: 5px 0;

}
.doctor-1 {
    font-size: 16px;
  font-weight: bold;
  margin-right: 5px;
  text-align: left;
}
.desc {
  line-height: 1.4;
  font-size: 14px;
  text-align: left;
}
.right-val {
  width: calc(100% - 60px);
  font-size: 14px;
  color: #333333;
  margin-top: 10px;
}
.left-title {
  color: #999999;
  width: 60px;
}
</style>
